import React, { Component } from "react";
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import '../../SCSS/tabs.scss';
// import '../../scss/working-hours.scss';
import AttachmentIcon from "@material-ui/icons/Attachment";
// import '../../scss/setting.scss';
import ZenForm from './form';
import Axios from "axios";
import Button from '@material-ui/core/Button';
import KenTable from '../KenTable/index';
// import Loader from "../../utils/loader/loaders";
import KenPaginationUI from "../KenPaginator/index";
import { Alert } from 'rsuite';
// import addCircle from '../../assets/images/add_circle.png';
// import removeCircle from '../../assets/images/remove_circle.png';
import { SelectPicker, Checkbox, DatePicker, Input, CheckPicker } from "rsuite";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from '@material-ui/core/Switch';
import { withStyles, Theme, createStyles } from '@material-ui/core/styles';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import IconButton from '@material-ui/core/IconButton';

const AntSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 28,
      height: 16,
      padding: 0,
      display: 'flex',
    },
    switchBase: {
      padding: 2,
      color: theme.palette.grey[500],
      '&$checked': {
        transform: 'translateX(12px)',
        color: theme.palette.common.white,
        '& + $track': {
          opacity: 1,
          backgroundColor: "#0052CC",
          borderColor: theme.palette.primary.main,
        },
      },
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: 'none',
    },
    track: {
      border: `1px solid ${theme.palette.grey[500]}`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.common.white,
    },
    checked: {},
  }),
)(Switch);
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
export default class ZenTabs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tabData: {},
      activeTab: 0,
      form: false,
      submitCheck: false,
      loader: false,
      tabEdit: false,
      clear: false,
      env: JSON.parse(localStorage.getItem("env")),
      useremail: localStorage.getItem("email"),
      channel: localStorage.getItem("channel"),
      BranchId: localStorage.getItem("branchid"),
      authToken: localStorage.getItem("auth_token"),
      orgId: localStorage.getItem("orgId"),
      orgName: localStorage.getItem("orgName"),
      userId: localStorage.getItem("userID"),
      workExpData1: [

      ],
      page: 1,
      limit: 15,
      totalRecord: 0,
      totalPages: 1,
      workingHoursData: [],
      isHalfDay: [
        {
          label: 'Yes',
          value: 'Yes'
        },
        {
          label: 'No',
          value: 'No'
        }
      ],
      tableResponse: "Fetching Details..",
      seletPickerData: [
        {
          "label": "Week Off",
          "value": "Week Off"
        },
        {
          "label": "Half Day Off",
          "value": "Half Day Off"
        },
        {
          "label": "1st",
          "value": "1st"
        },
        {
          "label": "2nd",
          "value": "2nd"
        },
        {
          "label": "3rd",
          "value": "3rd"
        },
        {
          "label": "4th",
          "value": "4th"
        },
        {
          "label": "5th",
          "value": "5th"
        }
      ],
      halfDaychecked: true,
      WorkingHrstabData: [],
      workingFrom: new Date().getTime(),
      workingTo: new Date().getTime(),
      workingHoursChecked: true,
      inputData: {},
      filename: '',
    }
    this.inputFile = React.createRef(this.inputFile);
  }
  componentDidMount = () => {
    if (this.props.wh != undefined) {
      if (this.props.wh) {
        let tabData = [];
        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        this.props.wdData.map(day => {
          let opts = []
          this.state.seletPickerData.map(item => {
            opts.push(
              {
                "label": `${item.label} ${day.Day}`,
                "value": `${item.value} ${day.Day}`
              }
            )
          })
          tabData.push({
            "Day": day.Day,
            "weekoff": day.weekoff,
            opts: opts
          })
        })
        this.setState({ WorkingHrstabData: tabData, loader: false });
      } else {
        let tabData = [];
        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        days.map(day => {
          let opts = []
          this.state.seletPickerData.map(item => {
            opts.push(
              {
                "label": `${item.label} ${day}`,
                "value": `${item.value} ${day}`
              }
            )
          })
          tabData.push({
            "Day": day,
            "weekoff": null,
            opts: opts
          })
        })
        this.setState({ WorkingHrstabData: tabData, loader: false });
      }
    }

    this.setState({ workExpData1: this.props.workExpData })
    console.log("this.props", this.props.workExpData)
  }
  getWorkingHoursData = () => {
    this.setState({ loader: true })
    var headers = {
      'Authorization': localStorage.getItem('auth_token')
    }
    Axios.get(`${this.state.env['getUserProfile']}/masters/workingday?org=${this.state.orgId}`, { headers: headers })
      .then(res => {
        if (res.data.status == 'success') {
          let sortWorkingHours = []
          let data = res.data.data;
          console.log("data", data)
          let tabData = [];
          var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

          if (data.length > 0) {
            this.setState({ WorkingHrstabData: tabData, loader: false });
          } else {
            days.map(day => {
              tabData.push({
                "Day": day,
                "weekoff": null
              })
            })
            this.setState({ WorkingHrstabData: tabData, loader: false });
          }

        }
      }).catch(err => {
        this.setState({ WorkingHrstabData: [], tableResponse: 'No Data' });
      })
  };
  componentWillMount = () => {
    console.log('props', this.props)
    this.setState({
      tabData: this.props.tabData,
      workExpData: this.props.workExpData !== undefined ? this.props.workExpData : this.state.workExpData,
      form: this.props.form,
      tabEdit: this.props.tabEdit == undefined ? false : this.props.tabEdit,
      clear: this.props.clear == undefined ? false : this.props.clear,
      activeTab: this.props.activeTab != undefined ? this.props.activeTab : 0
    })
  }
  handleRowDel = (product) => {
    let { workExpData1 } = this.state;
    if (workExpData1.length > 1) {
      var index = workExpData1.indexOf(product);
      workExpData1.splice(index, 1);
      console.log(workExpData1)
      workExpData1.map((item, i) => {
        // if(index < i) {
        item['id'] = i + 1
        // }
      })
      this.setState({ workExpData1: [] }, () => {
        this.setState({ workExpData1 })
      });
    }
  };
  handleAddEvent = () => {

    var id = this.state.workExpData1.length
    var product = {
      id: id + 1,
      "companyName": '',
      "from": '',
      "to": '',
      attachments: []
    }
    // this.state.workExpData1.push(product);
    let workExperience = [...this.state.workExpData1, product]
    this.setState({ workExpData1: [] }, () => {
      this.setState({ workExpData1: workExperience })
    });
  }
  handleChange = (event, value) => {
    Object.keys(this.state.tabData).map((tab, tabIndex) => {
      if (tab == 'Working Hours') {
        let jobTypeValue = this.props.form && this.props.form.General[1]['defaultValue']
        let jobTypeArray = []
        this.state.WorkingHrstabData.filter(item => {
          console.log('item', item)
          if (String(item.jobType).toLowerCase() == String(jobTypeValue).toLowerCase()) {
            jobTypeArray.push(item)
          }
        })
        this.setState({ WorkingHrstabData: jobTypeArray }, () => {
          this.setState({ activeTab: value })
          this.props.handleTabChange(value, this.props.form)
        });
      }
      else {
        console.log(event, value)
        this.setState({ activeTab: value })
        this.props.handleTabChange(value, this.props.form)
      }
    })


  }

  halfDaySwitch = (event, value) => {
    this.setState({ halfDaychecked: !this.state.halfDaychecked }, () => {
      console.log(this.state.halfDaychecked)
    })
    // console.log(event, value)
    // this.state.workingHoursData.map(item => {
    //   if (item.Day == event.target.name) {
    //     item['isHalfDay'] = value ? 'Yes' : 'No'
    //   }
    //   return item
    // })
    this.setState({ workingHoursData: this.state.workingHoursData });
  }
  onSubmit = (e) => {
    let type = e.currentTarget.innerText
    e.preventDefault();
    let fd = this.state.tabData
    let submitCheck = false
    Object.keys(fd).forEach(item => {
      fd[item].forEach(tab => {
        if (tab.required && tab.requiredBoolean) {
          if (!tab.validation) {
            submitCheck = true
            tab['error'] = true
            tab['errorMsg'] = `Invalid ${tab.label}`
          } else {
            submitCheck = submitCheck
            tab['error'] = false
          }
        }
      })
    })
    this.setState({ submitCheck: submitCheck, tabData: fd }, () => {
      if (!this.state.submitCheck) {
        this.props.onTabFormSubmit(this.props.tabData, this.props.form, String(type).toLowerCase())
      } else {
        Alert.error("Please check your data!")
      }
    })
    // this.props.onSubmit(data, item)
  }
  onInputChanges = (value, item, event, dataS, optIndex) => {
    console.log(value, item, event, dataS)
    // item['defaultValue'] = value
    // if (this.props.onInputChanges != undefined) {
    //   this.props.onInputChanges(value, item, event, dataS)
    // }
    if (this.props.onInputChanges != undefined) {
      if (dataS != undefined) {
        dataS['error'] = false
      } else {
        if (item != undefined) {
          item['error'] = false
        }
      }
      this.props.onInputChanges(value, item, event, dataS, optIndex)
    }
  }

  handleLibraryData = (libraryData, item) => {
    this.props.handleLibraryData(libraryData, item)
  }
  onFormBtnEvent = (item) => {
    console.log('check')
    this.props.onFormBtnEvent(item)
  }
  onPreviewWorkExperience = (item) => {
  }
  handleToggleChange = (e) => {
    this.setState({ [e.target.name]: e.target.checked });
  };
  onPaginationChange = (page, limit) => {
    this.setState({ page: page, limit: limit }, () => {
      this.getWorkingHoursData();
    });
  };
  onTrAction = (type, item) => {
    if (this.props.onTrAction != undefined) {
      this.props.onTrAction(type, item)
    }
  }

  onTableRowAction = (item, itemIndex, key) => {
    console.log(item)
    console.log(itemIndex)
    if (key == 'add') {
      let workExpData1 = this.state.workExpData1
      workExpData1.push({
        id: itemIndex + 2,
        companyName: "",
        fromDate: '',
        toDate: '',
        attachments: []
      })
      this.setState({ workExpData1: [] }, () => {
        this.setState({ workExpData1 })
      })
    } else {
      let workExpData1 = [];
      this.state.workExpData1.map((item, i) => {
        if (this.state.workExpData1.length > 1) {
          if (itemIndex != i) {
            workExpData1.push(item)
          }
        } else {
          workExpData1.push(item)
        }
      })
      this.setState({ workExpData1: [] }, () => {
        this.setState({ workExpData1 })
      })
    }
  }
  onTableColInputChanges = (e, item, itemIndex, key) => {
    console.log(e.target.value)
    console.log(item)
    console.log(itemIndex)
    let workExpData1 = this.state.workExpData1
    workExpData1[itemIndex][key] = e.target.value
    this.setState({ workExpData1: [] }, () => {
      this.setState({ workExpData1 })
    })
  }

  fileSelected = (item, index, e) => {
    // debugger
    let file = e.target.files
    let workExpData1 = this.state.workExpData1
    let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    let bytes = file[0]['size']
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    workExpData1[index]['attachments'].push({
      file: file[0],
      name: file[0].name,
      size: Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    })
    this.setState({ workExpData1: [] }, () => {
      this.setState({ workExpData1 })
    })
  }


  // fileSelected = (ev, i) => {
  //   console.log(ev.target.files)

  //   // let workBook = null;
  //   // let jsonData = null;
  //   // const reader = new FileReader();
  //   const file = ev.target.files[0];
  //   this.setState({ upload: true, filename: file.name, uploadTemplatePayload: file }, () => {
  //     this.onLoad(0)
  //   })
  // }


  handlecompanyData = (e, name, item) => {
    console.log("e", item)
    let workExpData1 = this.state.workExpData1;
    workExpData1.map((dataItem, index) => {
      if (dataItem.id == item.id) {
        dataItem["companyName"] = e.target.value
      }
      return dataItem
    })
    // workExpData1[name] = e.target.value;
    this.setState({ workExpData1 }, () => {
      console.log("workExpData1", workExpData1)
      this.setState({ workExpData1 })
    })
  }
  onSelect = (value, item, e, dataS, index) => {
    console.log(value);
    console.log(item);
    console.log(e);
    console.log(dataS);
    console.log(index);
    let workExpData1 = this.state.workExpData1;
    workExpData1.map((dataItem, i) => {
      if (i == index) {
        dataItem["fromDate"] = value
      }

    })
    this.setState({ workExpData1 }, () => {
      console.log("workExpData1", workExpData1)
      this.setState({ workExpData1 })
    })
  };

  onSelect2 = (value, item, e, dataS, index) => {
    console.log(value);
    console.log(item);
    console.log(e);
    console.log(dataS);
    console.log(index);
    let workExpData1 = this.state.workExpData1;
    workExpData1.map((dataItem, i) => {
      if (i == index) {
        dataItem["toDate"] = value
      }

    })
    this.setState({ workExpData1 }, () => {
      console.log("workExpData1", workExpData1)
      this.setState({ workExpData1 })
    })
  }
  onWHSelect = (value, item, event, i) => {
    console.log(value, item, event, i)
    let WorkingHrstabData = this.state.WorkingHrstabData
    WorkingHrstabData[i]['weekoff'] = value
    this.setState({ WorkingHrstabData }, () => {
      console.log(this.state.WorkingHrstabData)
      this.props.WorkingHrstabData(this.state.WorkingHrstabData)
    })
  }

  render() {
    const onButtonClick = () => {
      this.inputFile.current.click()
    }

    //  console.log("workhrs", this.state.WorkingHrstabData)
    return (
      <div className="tab-wrapper">
        <Paper square>
          <React.Fragment>
            <Tabs
              value={this.state.activeTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={this.handleChange}
            >
              {Object.keys(this.state.tabData).map((tab, tabIndex) => {
                return <Tab label={tab} />
              })}
            </Tabs>
            {Object.keys(this.state.tabData).map((tab, tabIndex) => {
              if (tab == 'Work Experience') {
                return <TabPanel value={this.state.activeTab} index={tabIndex}>
                  {this.state.form ? <React.Fragment>
                    <div className={this.props.preview ? "pre-btn" : "tab-form-btn-wrap "}>
                      <Button variant="contained" type="save" class="secondary-btn form-save-btn">Save</Button>
                      <Button variant="contained" type="submit" class="primary-btn form-submit-btn" onClick={this.onSubmit}>Submit</Button>
                    </div>
                    {/* {this.state.workExpData1.length > 0 ?
                      <div className="remove-last-child-table remove-first-child-table" style={{ position: 'relative', width: '96%' }} >
                        <React.Fragment>
                          <ZqTable data={this.state.workExpData1} rowClick={(item) => { this.onPreviewWorkExperience(item) }} checked={false} />
                          <img src={addCircle} onClick={this.handleAddEvent.bind(this)} className="invoice-addNewItem" alt="Add Item" title="Add New item" style={{ position: "absolute", cursor: 'pointer', right: "-32px", top: "48px", width: "22px" }} />
                          <img src={removeCircle} onClick={this.handleRowDel.bind(this)} className="remove-row-icon payslip-remove" alt="Delete Item" title="Delete item" style={{ position: "absolute", cursor: 'pointer', right: "-58px", top: "48px", width: '22px' }} />
                        </React.Fragment>

                      </div>
                      : <p>No Data</p>} */}
                    <div className="table-wrapper investment-declaration-table">
                      {this.state.workExpData1.length === 0 ? null :
                        <React.Fragment>
                          <table className="zq-table-wrap" style={{ background: "#fff" }}>
                            <thead className="zq-table-heading">
                              <tr>
                                <th style={{ width: "5%" }}>Id</th>
                                <th style={{ width: "30%" }}>Company Name</th>
                                <th style={{ width: "15%" }}>From Date</th>
                                <th style={{ width: "15%" }}>To Date</th>
                                <th style={{ width: "25%" }}>Attachments</th>
                                <th style={{ width: "5%" }}></th>
                                <th style={{ width: "5%" }}></th>
                              </tr>
                            </thead>
                            <tbody className="zq-table-body">
                              {
                                this.state.workExpData1.map((item, itemIndex) => {
                                  return <tr key={itemIndex}>
                                    <td>{itemIndex + 1}</td>
                                    <td>
                                      <div className="dec-form-input align-item-start other-income-input-wrap" style={{ width: "100%" }}>
                                        <div className="input-wrap employeeworkExperience" style={{ marginBottom: "0px !important" }}>
                                          <TextField
                                            name="companyName"
                                            id="companyName"
                                            variant="filled"
                                            type="text"
                                            defaultValue={item.companyName}
                                            onChange={(e) => { this.handlecompanyData(e, "companyName", item) }}
                                          // onBlur={(e) => this.onTableColInputChanges(e, item, itemIndex, 'companyName')}
                                          >
                                          </TextField>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="dec-form-input align-item-start other-income-input-wrap" style={{ width: "100%" }}>
                                        <div className="input-wrap employeeworkExperience" style={{ marginBottom: "0px !important" }}>
                                          {/* <TextField
                                            name="from"
                                            id="from"
                                            variant="filled"
                                            type="date"
                                            defaultValue={item.from}
                                            onBlur={(e) => this.onTableColInputChanges(e, item, itemIndex, 'from')}>
                                          </TextField> */}
                                          <DatePicker
                                            name="from"
                                            id="from"
                                            className="select-input-wrap date-wrap dec-bottom-wrap "
                                            defaultValue={item.fromDate}

                                            onSelect={(value, item, event) =>
                                              this.onSelect(value, item, event, this.state.workExpData1, itemIndex)
                                            }
                                            key={itemIndex}
                                            format="DD-MM-YYYY"
                                          />
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="dec-form-input align-item-start other-income-input-wrap" style={{ width: "100%" }}>
                                        <div className="input-wrap employeeworkExperience" style={{ marginBottom: "0px !important" }}>
                                          {/* <TextField
                                            name="to"
                                            id="to"
                                            variant="filled"
                                            type="date"
                                            defaultValue={item.to}
                                            onBlur={(e) => this.onTableColInputChanges(e, item, itemIndex, 'to')}>
                                          </TextField> */}
                                          <DatePicker
                                            name="to"
                                            id="to"
                                            className="select-input-wrap date-wrap dec-bottom-wrap "
                                            defaultValue={item.toDate}

                                            onSelect={(value, item, event) =>
                                              this.onSelect2(value, item, event, this.state.workExpData1, itemIndex)
                                            }
                                            key={itemIndex}
                                            format="DD-MM-YYYY"
                                          />
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div className="dec-form-input align-item-start other-income-input-wrap" style={{ width: "100%" }}>
                                        <div className="input-wrap employeeworkExperience" style={{ marginBottom: "0px !important" }}>

                                          <TextField
                                            name="attachments"
                                            id="attachments"
                                            variant="filled"
                                            type="file"
                                            onChange={(e) => { e.stopPropagation(); this.fileSelected(item, itemIndex, e) }}
                                          // onBlur={(e) => this.onTableColInputChanges(e, item, itemIndex, 'attachments')}
                                          >
                                          </TextField>
                                          {item.attachments != undefined ? item.attachments.length > 0 ? item.attachments.map((attachment, ai) => {
                                            return <p style={{ marginTop: "7px" }} key={ai}>{attachment.name}</p>
                                          }) : null : null}
                                          {/* <input
                                            type='file'
                                            id='file'
                                            ref={this.inputFile}
                                            style={{ display: 'none' }}
                                            onChange={this.fileSelected}
                                          /> */}
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      {(this.state.workExpData1.length == (Number(itemIndex) + 1)) ? <IconButton onClick={(e) => this.onTableRowAction(item, itemIndex, 'add')}>
                                        <AddCircleOutlineIcon />
                                      </IconButton> : null}
                                    </td>
                                    <td><IconButton onClick={(e) => this.onTableRowAction(item, itemIndex, 'delete')}> <RemoveCircleOutlineIcon />
                                    </IconButton>
                                    </td>
                                  </tr>
                                })
                              }
                            </tbody>
                          </table>
                        </React.Fragment>}
                    </div>

                  </React.Fragment> : <React.Fragment>
                  </React.Fragment>}
                </TabPanel>

              } else if (tab === "Working Days") {
                return (<>
                {/* {this.state.loader ? <Loader /> : null} */}
                  <TabPanel value={this.state.activeTab} index={tabIndex}>
                    <div className={this.props.preview ? "pre-btn" : "tab-form-btn-wrap "}>
                      {/* <Button variant="contained" type="clear" class="secondary-btn form-clear-btn" onClick={() => this.onFormBtnEvent('clear')}>Clear</Button> */}
                      {/* <Button variant="contained" type="cancel" class="secondary-btn form-cancel-btn" onClick={() => this.onFormBtnEvent('cancel')}>Cancel</Button> */}
                      <Button variant="contained" type="save" class="secondary-btn form-save-btn">Save</Button>
                      <Button variant="contained" type="submit" class="primary-btn form-submit-btn" onClick={this.onSubmit}>Submit</Button>
                    </div>
                    <div className={this.state.tab === 1 ? "tab-cont op-1" : "tab-cont op-0"}>
                      <div className="tab-one-content-key full-setting-body">
                        {/* <div className="tab-one-content-header">
                  <p style={{ fontSize: "14px", color: "#061938" }}>WORK SETTING</p>
                </div> */}
                        <div className="address-form-wrapper seperateData">
                          <div className="table-wrapper workinghours-table">
                            <table className="zq-table-wrap settingTable workinghours-table-wrap">
                              <thead className="zq-table-heading">
                                <tr>
                                  <th style={{ width: "50%" }}>Working Days</th>
                                  <th style={{ width: "50%" }}>Weekly Time Off</th>
                                </tr>
                              </thead>
                              <tbody className="zq-table-body">
                                {this.state.WorkingHrstabData.map((item, i) => {
                                  return <tr>
                                    <td style={{ width: "50%" }}>{item.Day}</td>
                                    <td style={{ width: "50%" }}><CheckPicker
                                      className="select-picker-width working-hours"
                                      data={item.opts}
                                      appearance="default"
                                      placeholder=""
                                      defaultValue={item.weekoff}
                                      onSelect={(value, item, event) => this.onWHSelect(value, item, event, i)}
                                    /></td>
                                  </tr>
                                })}
                              </tbody>
                            </table>
                            {/* // } */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel></>)
              }

              else {
                return <TabPanel value={this.state.activeTab} index={tabIndex}>
                  {this.state.form ? <React.Fragment>
                    <div className={this.props.preview ? "pre-btn" : "tab-form-btn-wrap "}>
                      {/* <Button variant="contained" type="clear" class="secondary-btn form-clear-btn" onClick={() => this.onFormBtnEvent('clear')}>Clear</Button> */}
                      {/* <Button variant="contained" type="cancel" class="secondary-btn form-cancel-btn" onClick={() => this.onFormBtnEvent('cancel')}>Cancel</Button> */}
                      {this.props.isCancelBtn != undefined ?
                        <Button variant="contained" disableRipple={true} type="reject" className="secondary-btn form-save-btn" style={{ 'right': this.props.resignStatus != undefined ? this.props.resignStatus == "Send Relieving Letter" ? '205px' : '107px' : '107px' }} onClick={this.onSubmit}>Reject</Button> :
                        <Button variant="contained" disableRipple={true} type="cancel" className={`secondary-btn form-save-btn ${this.props.resignStatus != undefined ? this.props.resignStatus : "reject-btn"}`} onClick={this.onSubmit}>
                          {this.props.isApproveBtn != undefined ? "Reject" : this.props.resignStatus != undefined ? this.props.resignStatus == "Approve" ? "Reject" : this.props.resignStatus == "Recommended" ? "Not Recommended" : "Cancel" : "Cancel"}
                        </Button>}
                      <Button variant="contained" disableRipple={true} type="submit" class="primary-btn form-submit-btn" onClick={this.onSubmit}>{this.props.isApproveBtn != undefined ? "Approve" : this.props.resignStatus != undefined ? this.props.resignStatus : "Submit"}</Button>
                    </div>
                    <ZenForm inputData={this.state.tabData[tab]} clear={true} onInputChanges={this.onInputChanges} handleLibraryData={this.handleLibraryData} formClass={this.props.formClass} onTrAction={this.onTrAction} />
                  </React.Fragment> : <React.Fragment>
                  </React.Fragment>}
                </TabPanel>
              }
            })}
          </React.Fragment>
        </Paper>
      </div>
    )
  }
}
